import { TextInput } from '@ts/storybook';
import { IForm } from '@ts/ui-models';

const NumberValuesDefinition = (props: IForm) => {
  const { values, mode, onCallbackChange } = props;
  const isViewMode = mode === 'view';
  return (
    <>
      <TextInput
        type="number"
        isReadOnly={isViewMode}
        label="Min value"
        value={values.minValue}
        onChangeValue={onCallbackChange('minValue')}
      />
      <TextInput
        type="number"
        isReadOnly={isViewMode}
        label="Max value"
        value={values.maxValue}
        onChangeValue={onCallbackChange('maxValue')}
      />
    </>
  );
};

export default NumberValuesDefinition;
